import * as React from 'react';
import { VictoryBar, VictoryChart, VictoryAxis, VictoryTheme } from 'victory';

interface IProps {
    data: { x: string, y: number }[]
}

export default class Widget extends React.Component<IProps, void> {
    static propTypes = {
        data: React.PropTypes.array.isRequired,
    };

    render() {
        const { data } = this.props;

        return (
            <VictoryChart
                width={920}
                height={data.length * 24}
                padding={{ left: 120, right: 0, top: 5, bottom: 24 }}
                theme={VictoryTheme.material}
            >
                <VictoryAxis
                    tickCount={4}
                    style={{ tickLabels: { fontSize: 9, padding: 3 } }}
                />
                <VictoryAxis
                    dependentAxis
                    style={{ tickLabels: { fontSize: 9, padding: 3 } }}
                />
                <VictoryBar
                    data={data}
                    horizontal={true}
                />
            </VictoryChart>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/widget/common/Chart/HorizontalBarChart.tsx